module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAgMAAAAOFJJnAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTDJv/zBw/zNv/1pr7vgAAAADdFJOUwDfIMe4PcYAAABKSURBVBjTY2CgHRADEVOAWLaBgYGpBMhQT2Bg4LzBACFAHAamMgaGuQ0ghXMbQGywIrASkCKwEpAiiBKgojKo2eo3oAzOBAZaAgBKSg6YW3mPzgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shang.png
// module id = 5tqD
// module chunks = 1